<template>
    <FciDialog :title="this.$f.tc('variable')" v-model="show">
        <div class="VariableSelector">
            <v-text-field
                outlined
                dense
                hide-details
                :label="this.$f.tc('search')"
                class="mb-3"
                v-model="searchKey"
                clearable
            ></v-text-field>
            <v-layout>
                <v-flex>
                    <b>User defined</b>
                    <template v-for="variable in variableList">
                        <div v-if="variable.builtin === 0" :key="variable.name">
                            <v-checkbox
                                :label="variable.name"
                                dense
                                hide-details
                                class="mt-0"
                                v-model="variable.selected"
                                :class="{fade: isFade(variable.name)}"
                            ></v-checkbox>
                        </div>
                    </template>
                </v-flex>
                <v-flex>
                    <b>Builtin</b>
                    <template v-for="variable in variableList">
                        <div v-if="variable.builtin === 1" :key="variable.name">
                            <v-checkbox
                                :label="variable.name"
                                dense
                                hide-details
                                class="mt-0"
                                v-model="variable.selected"
                                :class="{fade: isFade(variable.name)}"
                                :disabled="!allowBuiltin"
                            ></v-checkbox>
                        </div>
                    </template>
                </v-flex>
            </v-layout>
            <v-layout class="mt-3">
                <v-btn color="primary" outlined @click="addVariable">{{ $t('addVariable') }}</v-btn>
                <v-flex></v-flex>
                <v-btn color="primary" @click="save">{{ $t('save') }}</v-btn>
            </v-layout>
        </div>
    </FciDialog>
</template>

<script>
import FciDialog from '@/components/FciDialog'
import DialogPromiseMixin from '@/modules/fptai/mixins/DialogPromiseMixin'
import { AppEventBusType } from '@/eventbus/app.eventbus'

export default {
    name: 'VariableSelector',
    components: { FciDialog },
    mixins: [DialogPromiseMixin],
    data () {
        return {
            searchKey: '',
            allowBuiltin: true,
            variableList: [],
            selectedList: []
        }
    },
    methods: {
        open (data) {
            this.selectedList = data.selectedList
            this.allowBuiltin = !!data.allowBuiltin
            this.updateData()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        updateData () {
            this.variableList = this.$store.state.scenario.variableList.map(item => ({
                builtin: item.builtin,
                name: item.name,
                selected: this.selectedList.includes(item.name)
            }))
        },
        isFade (name) {
            if (!this.searchKey) {
                return false
            }
            return !name.toLowerCase().includes(this.searchKey.trim().toLowerCase())
        },
        save () {
            this.close()
            this.promise.resolve(this.variableList.reduce((array, variable) => {
                if (variable.selected) {
                    array.push(variable.name)
                }
                return array
            }, []))
        },
        addVariable () {
            this.$appService.useEventBus(AppEventBusType.OPEN_VARIABLE_EDITOR, null).then(item => {
                this.$store.dispatch(this.$at.scenario.CREATE_VARIABLE, {
                    name: item.name,
                    entity: item.entity,
                    memory_type_id: item.memory_type_id,
                    is_scenario_scope: false
                }).then(() => {
                    this.updateData()
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
.VariableSelector {
    overflow: auto;
    padding: 10px;

    .fade {
        opacity: 0.3;
    }
}
</style>
